import {getPolicyTypes} from "../../services/subNationalService";

let cachedPolicyTypeOptions = null;

const fetchPolicyTypeOptions = async () => {
  if (!cachedPolicyTypeOptions) {
    try {
      const countryId = 2;
      const policyTypes = await getPolicyTypes(countryId);
      cachedPolicyTypeOptions = policyTypes.data.map((policyType) => ({
        label: policyType.name,
        value: policyType.id,
      }));
    } catch (error) {
      console.error("Failed to fetch policy types:", error);
      cachedPolicyTypeOptions = []; // Default to an empty array on failure
    }
  }
  return cachedPolicyTypeOptions;
};

export const getPolicyTypeOptions = fetchPolicyTypeOptions;